import styled from 'styled-components';
import { setTypography, calcPxToRem, setVh } from 'utils/styles/mixins';
import { colors, rfs } from 'utils/styles/theme';
import { createRFS } from 'utils/styles/rfs';
import { mediaDesktopLarge, mediaMobile } from 'utils/styles/responsive';

const _rfs = createRFS({ rfsBreakpoint: `3840px` });

export const Layout = styled.div`
  display: flex;
  flex-direction: column;

  align-items: center;
  color: ${colors.balticSea};
  ${_rfs(`${calcPxToRem(190)}rem`, `padding-left`)}
  ${_rfs(`${calcPxToRem(190)}rem`, `padding-right`)}
  ${mediaMobile(`
    ${_rfs(`${calcPxToRem(60)}rem`, `padding-left`)}
    ${_rfs(`${calcPxToRem(60)}rem`, `padding-right`)}
  `)}
  ul {
    list-style: inside;
  }
  > div {
    max-width: 1200px;
  }
`;

export const LayoutTitle = styled.div`
  min-height: ${setVh(90)};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: ${colors.pattensBlue};
  text-shadow: black 1px 0 55px;
`;

export const LayoutWrapper = styled.div`
  background-color: ${colors.white};
  padding-top: ${setVh(10)};
`;

export const Bg = styled.div`
  position: absolute;
  width: 100vw;
  height: ${setVh(100)};
  z-index: -1;
  background: gray;
`;

export const Title = styled.div`
  ${setTypography('heading1')}
  text-align: center;
  text-wrap: balance;
`;

export const Caption = styled.div`
  ${setTypography('caption')}
  ${rfs(`${calcPxToRem(50)}rem`, `margin-bottom`)}
`;

export const LayoutOverview = styled.div`
  ${_rfs(`${calcPxToRem(190)}rem`, `padding-left`)}
  ${_rfs(`${calcPxToRem(190)}rem`, `padding-right`)}
  ${rfs(`${calcPxToRem(50)}rem`, `margin-bottom`)};

  > div {
    display: flex;
    ${setTypography('caption')}
    > div:nth-child(1) {
      ${rfs(`0 0 ${calcPxToRem(165)}rem`, `flex`)}
    }
    > div:nth-child(2) {
      flex: 1 1;
    }
    ${mediaMobile(`
      flex-direction: column;
      > div:nth-child(1) {
        flex: 1 1;
      }
    `)}
  }
  > div:nth-child(1) {
    > div:nth-child(2) {
      display: flex;
      ${rfs(`${calcPxToRem(165)}rem`, `column-gap`)}
    }
  }
`;

export const LayoutBGWBackdrop = styled.div`
  background-color: ${colors.wildSand};
  ${_rfs(`${calcPxToRem(190)}rem`, `padding-left`)}
  ${_rfs(`${calcPxToRem(190)}rem`, `padding-right`)}
  ${rfs(`${calcPxToRem(80)}rem`, `padding-top`)}
  ${rfs(`${calcPxToRem(80)}rem`, `padding-bottom`)}
  ${rfs(`${calcPxToRem(100)}rem`, `margin-bottom`)}
  img {
    width: 100%;
  }
  ${mediaMobile(`
    ${_rfs(`${calcPxToRem(60)}rem`, `padding-left`)}
    ${_rfs(`${calcPxToRem(60)}rem`, `padding-right`)}
    ${rfs(`${calcPxToRem(40)}rem`, `padding-top`)}
    ${rfs(`${calcPxToRem(40)}rem`, `padding-bottom`)}
  `)}
`;

export const FlickityWrapper = styled.div`
  ${rfs(`${calcPxToRem(100)}rem`, `margin-top`)}
  ${rfs(`${calcPxToRem(100)}rem`, `margin-bottom`)}
`;
export const CarouselCell = styled.div`
  ${rfs(`${calcPxToRem(16)}rem`, `margin-right`)}

  width: 80%;
  img {
    width: 100%;
  }
  ${mediaMobile(`
    width: 100%;
  `)}
`;

export const LayoutBlock0 = styled.div`
  ${_rfs(`${calcPxToRem(190)}rem`, `padding-left`)}
  ${_rfs(`${calcPxToRem(190)}rem`, `padding-right`)}
  ${rfs(`${calcPxToRem(100)}rem`, `margin-bottom`)};

  display: flex;
  flex-direction: column;

  > div {
    display: flex;
    > div:nth-child(1) {
      ${setTypography('caption')}
      ${rfs(`0 0 ${calcPxToRem(165)}rem`, `flex`)}
    }
    > div:nth-child(2) {
      ${setTypography('heading5')}
      flex: 1 1;
    }
    ${mediaMobile(`
      flex-direction: column;
      row-gap: 16px;
      > div:nth-child(1) {
        flex: 1 1;
      }
    `)}
  }
`;

export const LayoutBlock1 = styled.div`
  ${rfs(`${calcPxToRem(100)}rem`, `margin-bottom`)};
  ${_rfs(`${calcPxToRem(190)}rem`, `padding-left`)}
  ${_rfs(`${calcPxToRem(190)}rem`, `padding-right`)}
  > div:nth-child(1) {
    ${setTypography('caption')}
    ${rfs(`${calcPxToRem(45)}rem`, `margin-bottom`)};
    ${mediaMobile(`
      margin-bottom: 16px;
    `)}
  }
  > div:nth-child(2) {
    display: flex;
    justify-content: space-between;
    ${rfs(`${calcPxToRem(50)}rem`, `column-gap`)}
    > div:nth-child(1) {
      ${setTypography('heading5')}
      flex: 1 1 50%;
    }
    > div:nth-child(2) {
      flex: 1 1 50%;
      ${setTypography('body2')}
      > div {
        margin-bottom: 16px;
      }
    }
    ${mediaMobile(`
      flex-direction: column;
      row-gap: 16px;
    `)}
  }
`;

export const LayoutBlock2 = styled.div`
  ${rfs(`${calcPxToRem(100)}rem`, `margin-bottom`)};
  ${_rfs(`${calcPxToRem(190)}rem`, `padding-right`)}
  display: flex;
  > div:nth-child(1) {
    ${setTypography('caption')}
    ${rfs(`0 0 ${calcPxToRem(165)}rem`, `flex`)}
  }
  > div:nth-child(2) {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    > div:nth-child(1) {
      ${setTypography('heading2')}
      ${rfs(`${calcPxToRem(45)}rem`, `margin-bottom`)};
    }

    > div:nth-child(2) {
      ${setTypography('body2')}
      > div {
        margin-bottom: 16px;
      }
    }
  }
  ${mediaMobile(`
    flex-direction: column;
    > div:nth-child(1) {
      flex: 1 1;
    }
  `)}
`;

export const LayoutImageWCaption = styled.div<{
  flexDirectionReversed?: boolean;
}>`
  display: flex;
  flex-direction: ${({ flexDirectionReversed }) =>
    flexDirectionReversed ? 'row-reverse' : 'row'};
  ${rfs(`${calcPxToRem(100)}rem`, `column-gap`)};
  ${rfs(`${calcPxToRem(100)}rem`, `margin-top`)};
  ${rfs(`${calcPxToRem(100)}rem`, `margin-bottom`)};
  > div:nth-child(1) {
    flex: 0 1 65%;
    img {
      width: 100%;
    }
  }
  > div:nth-child(2) {
    ${setTypography('caption')}
    flex: 1 0 20%;
    text-align: ${({ flexDirectionReversed }) =>
      flexDirectionReversed ? 'right' : 'left'};
  }

  ${mediaMobile(`
    flex-direction: column;
    row-gap: 16px;
    > div:nth-child(1) {
      flex: 1 1;
    }
    > div:nth-child(2) {
      flex: 1 1;
    }
  `)}
`;
